import React from 'react';
import { Link } from 'react-router-dom';

const LegalLinks: React.FC = () => {
  return (
    <span className="inline-flex items-center gap-2">
      <Link to="/terms" className="underline decoration-[#EAD9B5] hover:text-[#B88933]">
        Terms of Service
      </Link>
      <span aria-hidden="true">·</span>
      <Link to="/privacy" className="underline decoration-[#EAD9B5] hover:text-[#B88933]">
        Privacy Policy
      </Link>
    </span>
  );
};

export default LegalLinks;
